import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Car, LogOut, LayoutDashboard, User } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0B0F17]/80 border-b border-[#1E293B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-home-link">
          <div className="h-9 w-9 rounded-lg bg-[#39FF14] flex items-center justify-center">
            <Car className="h-5 w-5 text-[#0B0F17]" />
          </div>
          <span className="font-display font-extrabold text-xl tracking-tight text-slate-50">DAWAL</span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-3">
          {!user && (
            <>
              <Link to="/" data-testid="nav-booking-link">
                <Button variant="ghost" className="text-slate-300 hover:text-white hover:bg-[#1C2436]">Réserver</Button>
              </Link>
              <Link to="/login" data-testid="nav-client-login-button">
                <Button className="bg-[#39FF14] hover:bg-[#5CFF45] text-[#0B0F17] font-semibold">Connexion</Button>
              </Link>
            </>
          )}
          {user && user.role === "driver" && (
            <>
              <Link to="/dashboard" data-testid="nav-driver-dashboard-button">
                <Button variant="ghost" className="text-slate-300 hover:text-white hover:bg-[#1C2436]">
                  <LayoutDashboard className="h-4 w-4 mr-2" />Tableau de bord
                </Button>
              </Link>
              <Button onClick={() => { logout(); navigate("/"); }} variant="ghost"
                className="text-slate-400 hover:text-white" data-testid="nav-logout-button">
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          )}
          {user && user.role === "client" && (
            <>
              <Link to="/espace" data-testid="nav-client-space-button">
                <Button variant="ghost" className="text-slate-300 hover:text-white hover:bg-[#1C2436]">
                  <User className="h-4 w-4 mr-2" />Mon espace
                </Button>
              </Link>
              <Button onClick={() => { logout(); navigate("/"); }} variant="ghost"
                className="text-slate-400 hover:text-white" data-testid="nav-logout-button">
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
